<template>
  <div class="mb-3">
    <div class="d-flex flex-wrap justify-content-between align-items-center mb-2">
      <div class="d-flex align-items-center flex-wrap">
        <h2 class="mb-0 mr-3">{{ titulo }}</h2>
        <slot name="search-left"></slot>
      </div>

      <div class="d-flex align-items-center flex-wrap mt-2 mt-sm-0">
        <button
          v-if="showFiltros"
          class="btn btn-sm btn-principal mr-2"
          data-toggle="collapse"
          href="#filtroscollapse"
          role="button"
          aria-expanded="false"
          aria-controls="filtroscollapse"
          @click="$emit('desplegarFiltros')"
        >
          <i class="bi-filter"></i> Filtros
        </button>

        <button
          v-if="showDescargar"
          class="btn btn-sm btn-principal mr-2"
          @click="$emit('descargar')"
          title="Descargar listado completo"
        >
          <i class="bi-download"></i> Descargar listado completo
        </button>

        <button
          v-if="showNuevo"
          class="btn btn-sm btn-principal"
          data-toggle="tooltip"
          data-placement="top"
          :title="'Nuevo ' + titulo"
          @click="showEdit({}, 'add')"
        >
          <i class="bi-plus"></i> Nuevo {{ titulo }}
        </button>
      </div>
    </div>

    <div class="collapse mb-3" id="filtroscollapse" v-if="showFiltros">
      <div class="card card-body bg-light border-0 shadow-sm py-3 px-4">
        <div class="form-row align-items-end">
          <div class="form-group col mb-2">
            <label class="font-weight-bold small text-muted mb-1" :for="titulo + '_select'">Buscar por {{ titulo }}</label>
            <input
              @change="onChangeModel()"
              @keyup="onChangeModel()"
              @keyup.enter="buscar"
              type="text"
              class="form-control"
              :placeholder="'Filtrar por ' + titulo.toLowerCase() + '...'"
              :id="titulo + '_select'"
              :aria-label="titulo"
              v-model="vmodel"
            />
          </div>
          <div class="form-group col-md-3 mb-2">
            <label class="font-weight-bold small text-muted mb-1" for="activo">Por Estado</label>
            <select
              class="form-control"
              @change="onChangeModelActivo(); buscar();"
              v-model="vmodelActivo"
              aria-label="activo"
              id="activo"
            >
              <option value="">Todos los estados</option>
              <option value="1">Activo</option>
              <option value="0">Inactivo</option>
            </select>
          </div>
          <div class="form-group col-auto mb-2">
            <button @click="buscar" class="btn btn-info px-4">
              <i class="bi-search"></i> Buscar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "filtrosBox",

  data() {
    return {
      titulo: this.entidad,
      campos: [],
      vmodel: this.model,
      vmodelActivo: this.modelActivo,
    };
  },

  props: {
    entidad: {
      type: String,
      required: true,
    },
    model: {
      type: String,
    },
    modelActivo: {
      type: String,
    },
    showFiltros: {
      type: Boolean,
      default: true,
    },
    showDescargar: {
      type: Boolean,
      default: false,
    },
    showNuevo: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    showEdit(item, operation) {
      this.$emit("muestraModal", [item, operation]);
    },
    buscar() {
      this.$emit("buscar");
    },
    onChangeModel() {
      this.$emit("model", this.vmodel);
    },
    onChangeModelActivo() {
      this.$emit("modelActivo", this.vmodelActivo);
    },
  },
};
</script>

<style scoped>
</style>